"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var FileSize_1 = __importDefault(require("../display/FileSize"));
exports.DownloadButton = function (props) {
    var variant = props.variant, size = props.size, block = props.block, _a = props.onClick, onClick = _a === void 0 ? function () { } : _a;
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement(Button_1.default, { variant: variant, size: 'xl', block: block, onClick: function () { return onClick(); } },
        react_1.default.createElement("i", { className: "fa fa-download fa-fw" }),
        react_1.default.createElement("span", { className: "ml-2" }, t('download')),
        react_1.default.createElement("small", { className: "ml-2" },
            "(",
            react_1.default.createElement(FileSize_1.default, { documentSizeBytes: size }),
            ")")));
};
exports.DownloadButton.propTypes = {
    size: prop_types_1.default.string,
};
exports.DownloadButton.displayName = 'DownloadButton';
//# sourceMappingURL=DownloadButton.js.map